module.exports = __webpack_public_path__ + "img/category-favorite.38b003ee.png";